module.exports = __webpack_public_path__ + "static/media/louise-avatar.99e89a75.svg";